import React, { useState, useEffect } from 'react';
import { Container, Header, Title, Text, Button, Icon, Footer, Left, Body, Right, ListItem, Content, Separator, View, Card, CardItem, H3 } from 'native-base';
import { Platform, Linking, StyleSheet, Dimensions, ScrollView } from 'react-native';
import ShimmerPlaceHolder from 'react-native-shimmer-placeholder';
import Modal from './modal';
import Alert from './alert';
import { WebView } from 'react-native-webview';

export default function OnPageHelp({ path, fullUrl, setHelpPath }) {
	const [html, setHtml] = useState();
	const [visible, setVisible] = useState(false);
	const [currentUrl, setCurrentUrl] = useState(null);
	//console.log(path, fullUrl, currentUrl);

	useEffect(() => {
		//when path changes, display yourself
		if (path || fullUrl) {
			setVisible(true);
			const first = path && path.split('.')[0];
			const url = fullUrl || `https://calc.al/helpdocs/?u=${first}&i=${path}`;
			setCurrentUrl(url);
		}
		/*let response = await fetch(url, {
     method: 'GET',
     headers: heads
 });
 let result;*/
	}, [path, fullUrl]);

	const onNavigationStateChange = f => {
		//doClose();
	};

	const doClose = () => {
		setHelpPath && setHelpPath('');
		setVisible(false);
	};

	const { width, scale } = Dimensions.get('window');
	const zoom = width ? (width / (380 * scale)).toString() : '1';
	//__DEV__ && console.log(Dimensions.get('window'), zoom);
	//htmlContent = htmlContent && htmlContent.replace('<html>', '<html style="zoom:' + zoom + '">');

	return (
		<Modal
			isOpen={visible}
			backdropPressToClose
			coverScreen
			backdropColor="#295670"
			backButtonClose
			style={{ width: '90%', height: '90%', borderRadius: 10, backdropColor: '#FFF' }}
			swipeArea={100}
			backdropOpacity={0.5}
			onClosed={() => doClose()}
			//backdropOpacity={0.7}
			useNativeDriver>
			<Header style={{ height: 45, borderTopLeftRadius: 10, borderTopRightRadius: 10, width: '100%' }}>
				<Body>
					<Title>Help</Title>
				</Body>
				<Right>
					<Button transparent onPress={() => doClose()}>
						<Icon name="arrow-dropdown" />
					</Button>
				</Right>
			</Header>
			<View style={{ flex: 1, backgroundColor: '#FFF' }}>
				{visible &&
					currentUrl &&
					(Platform.OS == 'web' ? (
						<iframe style={{ border: 1, borderColor: '#444', borderStyle: 'dotted', margin: 10, flex: 1 }} src={currentUrl}></iframe>
					) : (
						<WebView
							style={{ backgroundColor: '#FFF', flex: 1, width: '100%' }}
							scalesPageToFit={false}
							automaticallyAdjustContentInsets={true}
							startInLoadingState={true}
							scrollEnabled={false}
							onNavigationStateChange={n => onNavigationStateChange(n)}
							source={{ uri: currentUrl }}
						/>
					))}
			</View>
		</Modal>
	);
}
